import React from 'react';
import { Stack, Button, Text, Heading, Dismissal, Link } from '@quotient/riq-react-ui';

const LoginDismissal = ({ show = false, url }) => {
  if (!show) return null;

  return (
    <Dismissal>
      <Stack direction="vertical" align="center" justify="center">
        <Heading as="h3">Log-In to your account</Heading>
        <Text>Save your shopping list and add coupons.</Text>
        <br />
        <Button size="small" css={{ width: '120px' }} as={Link} href={url} variant="secondary">
          log-in
        </Button>
      </Stack>
    </Dismissal>
  );
};

export { LoginDismissal };
